import { IEnvironment } from './environment.interface';
import { base } from './environment.base';

const projectId = 'spaq-mobile-development';

export const environment: IEnvironment = {
	...base,
	id: 'development',
	firebase: {
		apiKey: 'AIzaSyAlXGJVQx1iAgWiJq7eY2U7hrsrHCM_sEw',
		authDomain: 'spaq-mobile-development.firebaseapp.com',
		databaseURL: 'https://spaq-mobile-development.firebaseio.com',
		projectId,
		storageBucket: 'spaq-mobile-development.appspot.com',
		messagingSenderId: '416287612067',
		appId: '1:416287612067:web:88c6a8d36a833d63e0f316',
		measurementId: 'G-E2C8EZXSTF'
	},
	backendApiUrl: `https://${base.functionsRegion}-${projectId}.cloudfunctions.net`,
	recaptcha: {
		...base.recaptcha,
		disabled: true
	},
	scopes: {
		...base.scopes,
		public: {
			...base.scopes.public,
			hideTextNotApplicableLicensePlate: false
		}
	},
	parkDefinitions: {
		1813: {
			sectorIds: [1769, 1770],
			groups: ['G_EmployeDeduction', 'G_EmployeCredit', 'L_Etudiant', 'L_EtudiantSoir', 'L_EtudiantFC']
		},
		2015: {
			sectorIds: [2363],
			groups: [
				'S_EmployeDeduction',
				'S_EmployeCredit',
				'S_Etudiant',
				'S_EtudiantSoir',
				'S_EtudiantFC',
				'S_EtudiantETS',
				'S_EmployeETS'
			]
		}
	}
};
